import { ReactNode, useMemo } from 'react';

import { ApolloProvider as ApolloProviderBase } from '@apollo/react-hooks';

import { useAppDataFeature } from 'src/app/data';
import { StatsigFeatureKeys } from 'src/features';

import { createApolloClient } from './apollo-client';

export const ApolloProvider = ({
  frontbucketVersion,
  children,
}: {
  frontbucketVersion: string;
  children: ReactNode;
}) => {
  // When enabled, the Apollo client will use a split link to split the
  // communication operation by protocol:
  // - Websocket for subscriptions
  // - HTTP for queries and mutations
  const hasWebsocketSubscriptionsEnabled = useAppDataFeature(
    StatsigFeatureKeys.bbcPrLiveReloadM2
  );

  const apolloClient = useMemo(() => {
    return createApolloClient({
      frontbucketVersion,
      hasWebsocketSubscriptions: hasWebsocketSubscriptionsEnabled,
    });
  }, [frontbucketVersion, hasWebsocketSubscriptionsEnabled]);

  return (
    <ApolloProviderBase client={apolloClient}>{children}</ApolloProviderBase>
  );
};
